import {Component, OnInit, HostBinding} from '@angular/core';

import { NurseryService } from '../services/nursery.service';
import { faMapMarker} from "@fortawesome/free-solid-svg-icons/faMapMarker";

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  providers: [NurseryService]
})
export class ResultsComponent implements OnInit {
  nurseryResults;

  faMapMarker = faMapMarker;

  @HostBinding('style.height.px')
  height: number;
  @HostBinding('style.width.px')
  width: number;

  constructor(private nurseryService: NurseryService) { }

  ngOnInit() {
    // this.nurseryService.getNurseryData().then((data) => {
    //   this.nurseryResults = data;
    //   console.log(this.nurseryResults);
    // });
  }
}
